import React, {useState, useEffect} from "react";
import { axiosPrivate }from "../api/axios";
import './CreateProjectPage.css';
import { Select, MultiSelect } from '@mantine/core';

const SelectTenantNInspection = ({onSelection}) => {
    const [tenants, setTenants] = useState([]);
    const [inspections, setInspections] = useState([]);
    const [selectedTenant, setSelectedTenant] = useState('');
    const [selectedInspections, setSelectedInspections] = useState('');

    const storedAuth = JSON.parse(sessionStorage.getItem("aimauth"));
    const accessToken = storedAuth?.accessToken;
    //fetch tenants
    useEffect(() => {
        if (tenants.length > 0) return;
        const fetchTenants = async () => {
            const response = await axiosPrivate.post('/api/getTenants', {}, {
                headers: {
                    'x-access-token': accessToken
                }
            });

            console.log('fetched', response.data);
            setTenants(response.data);
            setInspections([]);
            setSelectedTenant('');
        };
        fetchTenants();
    }, [tenants,accessToken]);

    //fetch inspections
    useEffect(() => {
        if (selectedInspections) return;
        const fetchInspections = async () => {
            console.log('selectedTenant', selectedTenant);
            const tenant = tenants.find(tenant => tenant.name === selectedTenant);
            if (!tenant) return;
            const response = await axiosPrivate.post(`/api/getInspections`, {
                tenantId: tenant.id
            }, {
                headers: {
                    'x-access-token': accessToken
                }
            });
            console.log(`fetched inspections by tenant id ${tenant.id}`, response.data);
            setInspections(response.data);
            setSelectedInspections('');
        };
        fetchInspections();
    }, [selectedTenant, selectedInspections, tenants, accessToken]);

    const handleTenantChange = (e) => {
        setSelectedTenant(e);
        setSelectedInspections('');
    };

    const handleInspectionChange = (e) => {
        setSelectedInspections(e);
        if (onSelection) {
            const tenant = tenants.find(tenant => tenant.name === selectedTenant);
            const inspectionIds = e.map(elem => inspections.find(inspection => inspection.inspectionName === elem).id);
            onSelection({tenant, inspections: inspectionIds});
        }
    };

    return (
        <>
        <Select label="Select Tenant" data={tenants.map(tenant => tenant.name)} value={selectedTenant} onChange={handleTenantChange} />        

        { selectedTenant && (
            <MultiSelect label="Select Inspection" data={inspections.map(inspection => inspection.inspectionName)} value={selectedInspections} onChange={handleInspectionChange} />
        )}
        </>
    );
}

export default SelectTenantNInspection;
